import { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';

import { dataGridPremiumColumns, getContrastColor } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import documentPiorityService from '../../service/documentPiority.service';

const DocumentPiorityReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection, documentTypes }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;
  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  useEffect(() => {
    if (operatorsDisabled) setRowSelectionModel([]);
  }, [operatorsDisabled]);

  const columns = useMemo(
    () =>
      dataGridPremiumColumns([
        {
          field: 'documentTypeId',
          headerName: 'Bizonylattípus',
          type: 'string',
          renderCell: (data) =>
            data.row?.documentType?.name ||
            documentTypes.find((item) => item.documentTypeId === data.row?.documentTypeId)?.name ||
            '',
        },
        {
          field: 'name',
          headerName: 'Prioritás',
          type: 'string',
          renderCell: (data) => {
            const color = data.row?.color;
            return (
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  px: 1,
                  ...(color
                    ? { backgroundColor: `${color} !important`, color: `${getContrastColor(color)} !important` }
                    : {}),
                }}
              >
                {data.row?.name}
              </Box>
            );
          },
        },
        { field: 'visOrder', headerName: 'Sorrend', type: 'number', filterable: false },
        { field: 'defaultValue', headerName: 'Alapértelmezett', type: 'boolean' },
        { field: 'active', headerName: 'Aktív', type: 'boolean' },
      ]),
    [documentTypes]
  );

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.DocumentPiority}
      datagridInitialState={{
        filter: { filterModel: { items: [], logicOperator: 'and' } },
        sorting: { sortModel: [{ field: 'visOrder', sort: 'asc' }] },
        pagination: { paginationModel: { pageSize: 25, page: 0 } },
        density: 'compact',
      }}
      dataLoader={(gridState) => documentPiorityService.getItems(gridState).then(setReports)}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={columns}
      onRowClick={(rowData) => {
        if (viewField) setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={setRowSelectionModel}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
      getRowId={(row) => row.priorityId}
    />
  );
};

export default DocumentPiorityReports;
